import React from 'react';
import Image from 'next/image';
import { STATIC_FILE_URL } from '@/shared/constants';
import Link from 'next/link';
import './index.less';

const SaveSection = ({ linkTo = `/existing-brands/signup` }: { linkTo?: string }) => {
  return (
    <div className="save-section">
      <div className="save-section-container">
        <div className="header">
          <h1>
            Designed to <span>2x your profits</span>
          </h1>
          <Link href={linkTo}>
            <button>
              <Image width={12} height={12} src="/images/phone.svg" alt="phone" />
              <p>Get in touch</p>
            </button>
          </Link>
        </div>
        <div className="table-container">
          <Image
            src={`${STATIC_FILE_URL}/877a7e08e589a13cc8c645cac0719de3.png`}
            alt="Typical company"
            width={287}
            height={381}
          />
          <Image
            src={`${STATIC_FILE_URL}/1fcfffbc0668c715471a1f94a8c9b0ad.png`}
            alt="Company built on Pietra"
            width={387}
            height={381}
          />
        </div>
      </div>
    </div>
  );
};

export default SaveSection;
